import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4" data-id="element-74">
      <div className="max-w-6xl mx-auto" data-id="element-75">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12" data-id="element-76">
          {/* Col 1 */}
          <div data-id="element-77">
            <div className="flex items-center gap-2 text-white mb-4" data-id="element-78">
              <LockIcon className="w-5 h-5 text-green-500" data-id="element-79" />
              <h3 className="font-bold text-lg" data-id="element-80">Pagamento Sicuro</h3>
            </div>
            <p className="text-sm mb-6" data-id="element-81">
              Transazioni protette con crittografia SSL a 256 bit. I tuoi dati
              sono al sicuro.
            </p>
            <PaymentBadges className="justify-start" data-id="element-82" />
          </div>

          {/* Col 2 */}
          <div data-id="element-83">
            <h3 className="font-bold text-white text-lg mb-4" data-id="element-84">Link Utili</h3>
            <ul className="space-y-2 text-sm" data-id="element-85">
              <li data-id="element-86">
                <a href="#" className="hover:text-white transition-colors" data-id="element-87">
                  Termini e Condizioni
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-white transition-colors" data-id="element-89">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-90">
                <a href="#" className="hover:text-white transition-colors" data-id="element-91">
                  Informativa sui Cookie
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-92">
            <h3 className="font-bold text-white text-lg mb-4" data-id="element-93">Contattaci</h3>
            <p className="text-sm mb-4" data-id="element-94">
              Hai bisogno di aiuto? Il nostro team è a tua disposizione.
            </p>
            <a href="mailto:info@activapleno.com" className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors" data-id="element-95">
              <MailIcon className="w-5 h-5" data-id="element-96" />
              info@activapleno.com
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-xs text-center space-y-4" data-id="element-97">
          <p data-id="element-98">
            Questo è un prodotto digitale. Nessun prodotto fisico verrà spedito.
          </p>
          <p data-id="element-99">© 2026 Plumcake Irresistibili. Tutti i diritti riservati.</p>
          <p className="opacity-60" data-id="element-100">
            Questo sito non fa parte del sito web di Facebook o di Facebook Inc.
            Inoltre, questo sito NON è approvato da Facebook in alcun modo.
            FACEBOOK è un marchio di FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}